import interceptor from '@/plugins/interceptor';
const pathController = "/Interactions";

export default {
    actions: {
        async interactions_get(_, params) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${pathController}/${params.studentId}?pageNumber=${params.page}&rowsPerPage=${params.rows}&eventTypeId=${params.type}`);
        },
        async interactions_getTypes() {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${pathController}/interactionType`);
        },
        async interactions_delete(_, id) {
            return await interceptor.authenticate.delete(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${pathController}/${id}`);
        },
        async interactions_post(_, body) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${pathController}`, body);
        },
        async forge_searchForgeUser(_, text) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}/ForgeUsers/${text}`);
        },
    }
}  
